
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({ name: 'CompetitionStageHeader' })
export default class CompetitionStageHeader extends Vue {}
